// extracted by mini-css-extract-plugin
module.exports = {"container":"headerFooterStyles_container__T__Ke","header":"headerFooterStyles_header__anb0M","mainContainerStyles":"headerFooterStyles_mainContainerStyles__8ME56"};